import BaseService from "./base.service";
class GenderType extends BaseService {
  constructor() {
    super("gender-type");
  }
}

export default new GenderType();
